import { render, staticRenderFns } from "./WatchAccList.vue?vue&type=template&id=490d5a69&scoped=true"
import script from "./WatchAccList.vue?vue&type=script&lang=js"
export * from "./WatchAccList.vue?vue&type=script&lang=js"
import style0 from "./WatchAccList.vue?vue&type=style&index=0&id=490d5a69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d5a69",
  null
  
)

export default component.exports